module.exports = __webpack_public_path__ + "img/map2.2a3add19.png";